/**
 * Loosely from https://stackoverflow.com/questions/1960473/get-all-unique-values-in-a-javascript-array-remove-duplicates
 *
 * Get all unique values from an array differentiated by a custom comparator function
 * Useful for getting unique objects where you cannot simply use a set
 *
 * @param {Array} list - list of items to get distinct values from
 * @param {Function} comparator - comparator function used to determine if two values are duplicates or not
 * @returns {Array} array with no duplciate values in it, determined by the comparator function
 */
export const getDistinct = (list, comparator) => list.filter((value, index, self) => self.findIndex((listItem) => comparator(listItem, value)) === index);
